<template>
  <div id="app">
    <div class="container-fluid">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
require("@/assets/main.css");
require("@/assets/responsive.css");

export default {
  name: "App"
};
</script>

<style></style>
